import type { LmsTrainingPlain } from 'src/interfaces/collectStepReference'

/**
 * In-memory search over the LMS training catalog. `externalId` is stringified so an admin can
 * paste a provider course id straight into the search box. Returns the input array by reference
 * for an empty query so an untouched search box does not churn the caller's `useMemo`.
 */
export const filterLmsTrainings = (
  trainings: LmsTrainingPlain[],
  search: string,
): LmsTrainingPlain[] => {
  const normalizedSearch = search.trim().toLowerCase()

  if (normalizedSearch === '') {
    return trainings
  }

  return trainings.filter((training) => {
    const haystack = [
      training.title,
      training.url,
      String(training.externalId),
      training.description ?? '',
      training.manualUploadRequirements ?? '',
    ]

    return haystack.some((value) => {
      return value.toLowerCase().includes(normalizedSearch)
    })
  })
}
